import { getTimeRemaining } from 'utilities/date';

function renderPromoCountdown (element, endtime, startServerTime, done, customPretext) {

	const formatCountdown = (t) => {

		const formattedTime = {
			days: t.days > 0 ? t.days : 0,
			hours: t.hours > 0 ? `${t.hours < 10 ? '0' : ''}${t.hours}` : 0,
			minutes: t.minutes,
			seconds: t.seconds
		};

		// do not drop minutes if minutes remaining is 0, but hours remaining is more than 0, instead show "00"
		if (t.hours > 0 && t.minutes === 0) {

			formattedTime.minutes = 0;

		}

		const {
			days, hours, minutes, seconds
		} = formattedTime;

		if (typeof customPretext === 'string') {

			return `${customPretext} <strong>${days}</strong>d <strong>${hours}</strong>hs <strong>${minutes}</strong>m <strong>${seconds}</strong>s`;

		}

		return `Ends in <strong>${days}</strong>d <strong>${hours}</strong>hs <strong>${minutes}</strong>m <strong>${seconds}</strong>s`;

	};

	const initializeClock = () => {

		const countDownElement = element;
		let timeinterval;
		let currentTime = new Date(startServerTime);

		const updateClock = () => {

			const timeRemaining = getTimeRemaining(endtime, new Date(currentTime).getTime());
			currentTime = new Date(currentTime.getTime() + 1000);

			countDownElement.innerHTML = formatCountdown(timeRemaining);

			if (timeRemaining.total <= 0) {

				clearInterval(timeinterval);
				done?.();

			}

		};

		updateClock();
		timeinterval = setInterval(updateClock, 1000);

	};

	if (!element) {

		return;

	}

	initializeClock();

}

export default renderPromoCountdown;
